import { GetLevelList } from '@src/services/level'

export const state = {
    levelList: [],
}
export const mutations = {
    SET_LEVEL_LIST(state, newList) {
        state.levelList = newList
    },
}

export const getters = {
    levelListIsLoaded(state) {
        return state.levelList.lenght !== 0
    },
}

export const actions = {
    async setLevelList({ commit }, params = {}) {
        const resp = await GetLevelList(params)
        if (resp.status === 200) {
            commit('SET_LEVEL_LIST', resp.data.data)
        }
    },
}
